import "./ResultBadge.css";

const RESULT_CLASSNAMES = {
    pass: "result-badge pass",
    fail: "result-badge fail",
    empty: "result-badge empty",
};

function ResultBadge({ value }) {
    const className = RESULT_CLASSNAMES[value] || RESULT_CLASSNAMES.empty;
    return (
        <div className="result-badge-container">
            <span className={className}>{(value || "empty").toUpperCase()}</span>
        </div>
    );
}

export default ResultBadge;
